<template>
  <el-row class="data_framework">
    <el-col :span="24">
      <!-- 侧边导航栏 -->
      <el-col :span="3" :style="{ height: innerHeight }">
        <el-menu router :default-active="$route.path" class="el-menu-vertical-demo">
          <template v-for="item in menuItems">
            <el-menu-item v-if="item.subMenu.length === 0" :key="item.index" :index="item.index">
              <i :class="item2icon[item.title]"></i>{{ item.title }}
            </el-menu-item>
            <el-submenu v-else :key="item.index" :index="item.index">
              <template slot="title">
                <i :class="item2icon[item.title]"></i>{{ item.title }}
              </template>
              <el-menu-item v-for="subItem in item.subMenu" :key="subItem.index" :index="subItem.index">
                {{ subItem.title }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </el-col>
      <!-- 右侧窗口栏 -->
      <el-col :span="21" :style="{ height: innerHeight }">
        <el-scrollbar class="routerview_scrollbar">
          <router-view></router-view>
        </el-scrollbar>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>
import GLOBAL from "@/utils/global.js";


export default {
  name: "Data",
  data() {
    return {
      clientHeight: "", // 浏览器可视高度
      innerHeight: "", // router-view可视高度

      // 导航栏图标
      item2icon: {
        首页: "el-icon-news",
        订单管理: "el-icon-receiving",
        商品管理: "el-icon-shopping-bag-1",
        优惠活动: "el-icon-sell",
        健康管理: "el-icon-data-analysis",
        商品审核: "el-icon-edit-outline",
        问题反馈: "el-icon-question",
        资质管理: "el-icon-s-management",
        数据管理: "el-icon-pie-chart",
        资质审核: "el-icon-reading",
      },

      // 导航栏数据格式
      menuItems: [
        {
          index: "/FrontPage",
          title: "首页",
          subMenu: [],
        },
        {
          index: "/OrderManagement",
          title: "订单管理",
          subMenu: [
            {
              index: "/OrderProcessing",
              title: "订单处理",
            },
            {
              index: "/OrderRecord",
              title: "订单记录",
            },
          ],
        },
        {
          index: "/CommodityManagement",
          title: "商品管理",
          subMenu: [],
        },
        {
          index: "/CommodityManagementHospitalVer",
          title: "商品管理",
          subMenu: [],
        },
        {
          index: "/CommodityCheckHospitalVer",
          title: "商品审核",
          subMenu: [],
        },
        {
          index: "/PromotionsManagement",
          title: "优惠活动",
          subMenu: [],
        },
        {
          index: "/DataAnalysis",
          title: "健康管理",
          subMenu: [],
        },
        {
          index: "/ProblemFeedBack",
          title: "问题反馈",
          subMenu: [],
        },
        {
          index: "/QualificationManagement",
          title: "资质管理",
          subMenu: [],
        },
        {
          index: "/QualificationHospitalVer",
          title: "资质审核",
          subMenu: [],
        },
        {
          index: "/DataVisualization",
          title: "数据管理",
          subMenu: [
            {
              index: "/DataCharts",
              title: "数据图表",
            },
            {
              index: "/ExcelExport",
              title: "表格导出",
            },
            {
              index: "/ExportTaskManagement",
              title: "导出任务管理",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {
    clientHeight() {
      this.updateInnerHeight(this.clientHeight);
    },
  },
  mounted() {
    // 根据浏览器高度自动条件routerview高度，控制scrollbar效果
    this.clientHeight = document.documentElement.clientHeight; // 获取浏览器可视区域高度
    let that = this;
    window.onresize = function () {
      this.clientHeight = document.documentElement.clientHeight;
      that.updateInnerHeight(this.clientHeight);
    };
    this.changeMenu();
  },
  updated() { },
  methods: {
    // 更新可视区域高度
    updateInnerHeight(clientHeight) {
      this.innerHeight = clientHeight - GLOBAL.topnavHeight + "px";
    },
    changeMenu() {
      const profile = sessionStorage.getItem("profile");
      if (profile) {
        //根据权限把部分侧边栏隐藏
        const userProfile = JSON.parse(profile);
        if (userProfile.role === 'checker') {
          this.menuItems[1].subMenu.splice(0,1);
          this.menuItems.splice(2, 1);
          this.menuItems.splice(4, 3);
          // this.menuItems[this.menuItems.length - 1].subMenu.splice(1,1);
        }
        else if(userProfile.role === 'admin'){
          this.menuItems.splice(3,2);
          this.menuItems.splice(6,1);
        }
        else if(userProfile.role === 'worker'){
          this.menuItems.splice(2);
        }
      }
    },
  }
};
</script>

<style>
@import "../style/Data.css";
@import "../style/Global.css";
</style>
